import React from 'react';
import { Tooltip, UncontrolledTooltip } from 'reactstrap';
// import { isNumber } from 'util';
import { timeConversion, convertToKib } from '../../assets/js/genericHelpers';

const TableExpand = (props) => {
  const { data } = props;
  const { details } = data;
  const { headings } = details;
  const { items } = details;
  let extractDescription = data.description.split('[');
  let extractUrl = extractDescription[1].split('(')[1].slice(0, -3);

  const openExternalLink = () => {
    window.open(extractUrl);
  };

  const openScreenshotLink = (link) => {
    window.open(link);
  };
  return (
    <div className='tableExpandContainer'>
      <div className='tableExpandDescription'>
        {extractDescription[0]}{' '}
        <span className='fw-6 passwordToggle' onClick={openExternalLink}>
          Learn More
        </span>
      </div>
      <table className='tableHeader'>
        <thead>
          <tr className='tableHeader-tr'>
            {headings.map((value) => {
              return (
                <th className='tableHeader-th'>
                  {value.hasOwnProperty('label') || value.hasOwnProperty('text')
                    ? value.label || value.text
                    : ''}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className='tableBody'>
          {items.map((itemValue, index) => {
            return (
              <tr className=''>
                {headings.map((headingValue) => {
                  if (
                    !headingValue.hasOwnProperty('label') &&
                    !headingValue.hasOwnProperty('text') &&
                    !itemValue.hasOwnProperty('subItems')
                  ) {
                    return (
                      <td>
                        <img
                          style={{ width: 48, height: 48 }}
                          src={itemValue.url}
                          alt={'...'}
                        />
                      </td>
                    );
                  } else if (
                    (headingValue.key === 'url' &&
                      headingValue.hasOwnProperty('label')) ||
                    (headingValue.key === 'url' &&
                      headingValue.hasOwnProperty('text')) ||
                    headingValue.text === 'Location'
                  ) {
                    return (
                      <td>
                        <div
                          id={'tableUrlContainer' + index}
                          className={`tableUrlContainer ${
                            headingValue.key === 'url' ? 'link' : ''
                          }`}
                          onClick={() => {
                            openScreenshotLink(itemValue[headingValue.key]);
                          }}
                        >
                          {itemValue[headingValue.key]}
                        </div>
                        {headingValue.key === 'url' && (
                          <UncontrolledTooltip
                            target={'tableUrlContainer' + index}
                            placement='bottom'
                          >
                            {itemValue[headingValue.key]}
                          </UncontrolledTooltip>
                        )}
                      </td>
                    );
                  } else if (
                    headingValue.key === 'element' &&
                    typeof itemValue[headingValue.key] === 'object' &&
                    !!itemValue[headingValue.key].value
                  ) {
                    return (
                      <td>
                        <div style={{ color: '#4f4fc5' }}>
                          {itemValue[headingValue.key].value}
                        </div>
                      </td>
                    );
                  } else {
                    return (
                      <td>
                        {typeof itemValue[headingValue.key] !== 'object'
                          ? typeof itemValue[headingValue.key] !== 'string'
                            ? headingValue.itemType === 'ms'
                              ? timeConversion(itemValue[headingValue.key])
                              : convertToKib(itemValue[headingValue.key])
                            : !!itemValue[headingValue.key]
                            ? itemValue[headingValue.key]
                            : itemValue.hasOwnProperty('subItems')
                            ? ''
                            : 'None'
                          : itemValue[headingValue.key].text}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableExpand;
